import { Share2, Twitter, Facebook, Linkedin, Link2 } from "lucide-react";
import { toast } from "sonner";

export const ShareButtons = ({ title = "", compact = false }) => {
  const url = typeof window !== "undefined" ? window.location.href : "";
  const enc = encodeURIComponent(url);
  const encT = encodeURIComponent(title);
  const links = [
    { icon: Twitter, label: "X", href: `https://twitter.com/intent/tweet?url=${enc}&text=${encT}`, id: "share-twitter" },
    { icon: Facebook, label: "Facebook", href: `https://www.facebook.com/sharer/sharer.php?u=${enc}`, id: "share-facebook" },
    { icon: Linkedin, label: "LinkedIn", href: `https://www.linkedin.com/sharing/share-offsite/?url=${enc}`, id: "share-linkedin" },
    { icon: Share2, label: "Pinterest", href: `https://pinterest.com/pin/create/button/?url=${enc}&description=${encT}`, id: "share-pinterest" },
  ];
  const copy = () => {
    navigator.clipboard.writeText(url);
    toast.success("Link copied to clipboard");
  };
  return (
    <div className="flex items-center gap-2" data-testid="share-buttons">
      {!compact && <span className="text-sm text-muted-foreground mr-1">Share:</span>}
      {links.map((l) => (
        <a key={l.id} data-testid={l.id} href={l.href} target="_blank" rel="noopener noreferrer"
          className="h-9 w-9 grid place-items-center rounded-full glass hover:text-primary hover:scale-110 transition-transform"
          aria-label={`Share on ${l.label}`}>
          <l.icon className="h-4 w-4" />
        </a>
      ))}
      <button data-testid="share-copy" onClick={copy}
        className="h-9 w-9 grid place-items-center rounded-full glass hover:text-primary hover:scale-110 transition-transform"
        aria-label="Copy link">
        <Link2 className="h-4 w-4" />
      </button>
    </div>
  );
};
